<div class="section-details select-patient-type">
  <select data-behaviour="uber-select" data-uber-options='{"ariaLabel": "Patient Type", "uberSelectId": "patient_type_selector"}'>
    <% jQuery.each(patient_types, function(key, value) { %>
      <option value="<%= key %>" <% if (key == selectedPatientType) { %> selected <% } %> ><%= value %></option>
    <% }) %>
  </select>
</div>
